<div class="otp-entry-view">
    <div class="otp-entry-view__icon-header">
        <clickme-loader variant="spinner" size="lg"></clickme-loader>
    </div>

    <p class="otp-entry-view__heading" [innerHTML]="headingLabel"></p>

    <clickme-otp-input
        #otpInput
        [digits]="length"
        [error]="hasError"
        [attr.aria-label]="headingLabel"
        (change)="onOtpChange($event)">
    </clickme-otp-input>

    @if (hasError && errorLabel) {
        <p class="otp-entry-view__error" role="alert">{{ errorLabel }}</p>
    }

    <div class="otp-entry-view__actions">

        <clickme-button
            variant="text"
            (click)="onGoBack()">
            {{ goBackLabel }}
        </clickme-button>
    </div>
</div>
